/**
 * Created by christiancueni on 06/07/16.
 * Copyright (c) 2016 ITerativ GmbH. All rights reserved.
 */
import {PasswordReset} from '../models';

import {type} from '../shared/util';
import {CustomAction} from './CustomAction';
import {Tokens, UserSettings} from '../models/auth';
import {HttpErrorResponse} from '@angular/common/http';

export const AuthActionTypes = {
  LOGIN: type("[Auth] Login"),
  LOGIN_SUCCESS: type("[Auth] Login Success"),
  LOGIN_FAILURE: type("[Auth] Login Failure"),
  VERIFY_EMAIL: type("[Auth] Verify Email"),
  VERIFY_EMAIL_SUCCESS: type("[Auth] Verify Email Success"),
  VERIFY_EMAIL_FAILURE: type("[Auth] Verify Email Failure"),
  PASSWORD_RESET: type("[Auth] Password reset"),
  PASSWORD_RESET_SUCCESS: type("[Auth] Password reset Success"),
  PASSWORD_RESET_FAILURE: type("[Auth] Password reset Failure"),
  GENERATE_VERIFY_EMAIL: type("[Auth] Generate Verify Email"),
  GENERATE_VERIFY_EMAIL_SUCCESS: type("[Auth] Generate Verify Email Success"),
  GENERATE_VERIFY_EMAIL_FAILURE: type("[Auth] Generate Verify Email Failure"),
  AUTH_LOAD_USER_DATA: type("[Auth] Load userdata"),
  AUTH_USER_TOKEN_RECEIVED: type("[Auth] Usertoken received"),
  AUTH_USER_DATA: type("[Auth] User Data"),
  AUTH_USER_DATA_SUCCESS: type("[Auth] User Data success"),
  AUTH_USER_DATA_FAIL: type("[Auth] User Data fail"),
  AUTH_LOGOUT: type("[Auth] Logout"),
  AUTH_LOGOUT_SUCCESS: type("[Auth] Logout success"),
  AUTH_REFRESH_TOKEN: type("[Auth] Refresh Token"),
  AUTH_REFRESH_TOKEN_SUCCESS: type("[Auth] Refresh token success"),
  AUTH_REFRESH_TOKEN_FAIL: type("[Auth] Refresh token fail"),
  FORGOT_PASSWORD_GENERATE: type("[Auth] Forgot password generate"),
  FORGOT_PASSWORD_GENERATE_SUCCESS: type("[Auth] Forgot password generate success"),
  FORGOT_PASSWORD_GENERATE_FAILURE: type("[Auth] Forgot password generate fail"),
  FORGOT_PASSWORD_RESET: type("[Auth] Forgot password reset"),
  FORGOT_PASSWORD_RESET_SUCCESS: type("[Auth] Forgot password reset Success"),
  FORGOT_PASSWORD_RESET_FAILURE: type("[Auth] Forgot password reset Failure"),
  ACTIVATION_LINK_GENERATE: type("[Auth] Activation link generate"),
  ACTIVATION_LINK_GENERATE_SUCCESS: type("[Auth] Activation link generate success"),
  ACTIVATION_LINK_GENERATE_FAILURE: type("[Auth] Activation link generate fail"),
  MULTIPLE_ACTIVATION_LINK_GENERATE: type("[Auth] Multiple activation link generate"),
  MULTIPLE_ACTIVATION_LINK_GENERATE_SUCCESS: type("[Auth] Multiple activation link generate success"),
  MULTIPLE_ACTIVATION_LINK_GENERATE_FAILURE: type("[Auth] Multiple activation link generate fail"),
  LOGIN_UPDATE_FORM_ERROR: type("[Auth] Login Update Formerror"),
  LOGIN_CLEAR_FORM_ERROR: type("[Auth] Login Remove Formerror"),
  AUTH_TOKEN_RESET: type("[Auth] Token reset"),
  AUTH_TOKEN_LOAD_LOCAL: type("[Auth] Token load local"),
  SET_LOGIN_REDIRECT_URL: type('[Auth] Set Login redirect url'),
  CLEAR_LOGIN_REDIRECT_URL: type('[Auth] Clear Login redirect url'),
  UPDATE_GROUP_SETTINGS: type('[Auth] Update Group Settings'),
  UPDATE_LATEST_NOTIFICATION_ID_SETTINGS: type('[Auth] Update Latest Notification ID Settings'),
  DISABLE_SHOW_RELATIONSHIP_ONBOARDING: type('[Auth] Disable show relationship onboarding'),
  DISABLE_SHOW_EVENT_ONBOARDING: type('[Auth] Disable show event onboarding'),
  UPDATE_SETTINGS: type('[Auth] Update Settings'),
  RESET_TOKEN: type('[Auth] Reset Token'),
  ACCEPT_UPDATE2019: type('[Auth] Accept Update 2019'),
  ACTIVATE_CODE: type('[Auth] Activate'),
  ACTIVATE_SUCCESS: type('[Auth] Activate Success'),
  ACTIVATE_FAIL: type('[Auth] Activate Fail'),
  ACTIVATE_CODE_FORM_ERROR: type('[Auth] Activate Form Error'),
  TOKEN_LOADED: type('[Auth] Token loaded'),
};

export class LoginAction implements CustomAction {
  type = AuthActionTypes.LOGIN;

  constructor(public payload: { username: string, password: string }) {
  }
}

export class LoginSuccessAction implements CustomAction {
  type = AuthActionTypes.LOGIN_SUCCESS;

  constructor(public payload: Object) {
  }
}

export class LoginFailureAction implements CustomAction {
  type = AuthActionTypes.LOGIN_FAILURE;

  constructor(public payload: Object) {
  }
}

export class LoadUserDataAction implements CustomAction {
  type = AuthActionTypes.AUTH_LOAD_USER_DATA;

  constructor() {
  }
}

export class AuthTokenReceivedAction implements CustomAction {
  type = AuthActionTypes.AUTH_USER_TOKEN_RECEIVED;

  constructor(public payload: Tokens) {
  }

}

export class UserDataAction implements CustomAction {
  type = AuthActionTypes.AUTH_USER_DATA;

  constructor() {
  }
}

export class UserDataSuccessAction implements CustomAction {
  type = AuthActionTypes.AUTH_USER_DATA_SUCCESS;

  constructor(public payload: Object) {
  }
}

export class UserDataFailAction implements CustomAction {
  type = AuthActionTypes.AUTH_USER_DATA_FAIL;

  constructor(public payload: string) {
  }
}

export class LogoutAction implements CustomAction {
  type = AuthActionTypes.AUTH_LOGOUT;

  constructor(public payload: boolean) {
  }
}

export class LogoutSuccessAction implements CustomAction {
  type = AuthActionTypes.AUTH_LOGOUT_SUCCESS;

  constructor(public payload: boolean) {
  }
}

export class AuthRefreshTokenAction implements CustomAction {
  type = AuthActionTypes.AUTH_REFRESH_TOKEN;

  constructor(public payload: string) {
  }
}

export class AuthRefreshTokenSuccessAction implements CustomAction {
  type = AuthActionTypes.AUTH_REFRESH_TOKEN_SUCCESS;

  constructor(public payload: { access: string }) {
  }
}

export class AuthRefreshTokenFailAction implements CustomAction {
  type = AuthActionTypes.AUTH_REFRESH_TOKEN_FAIL;

  constructor(public payload: string) {
  }
}

export class VerifyEmailAction implements CustomAction {
  type = AuthActionTypes.VERIFY_EMAIL;

  constructor(public payload: string) {
  }
}

export class VerifyEmailSuccessAction implements CustomAction {
  type = AuthActionTypes.VERIFY_EMAIL_SUCCESS;

  constructor(public payload: Object) {
  }
}

export class VerifyEmailFailureAction implements CustomAction {
  type = AuthActionTypes.VERIFY_EMAIL_FAILURE;

  constructor(public payload: Object) {
  }
}

export class GenerateVerifyEmailAction implements CustomAction {
  type = AuthActionTypes.GENERATE_VERIFY_EMAIL;

  constructor() {
  }
}

export class GenerateVerifyEmailSuccessAction implements CustomAction {
  type = AuthActionTypes.GENERATE_VERIFY_EMAIL_SUCCESS;

  constructor(public payload: Object) {
  }
}

export class GenerateVerifyEmailFailureAction implements CustomAction {
  type = AuthActionTypes.GENERATE_VERIFY_EMAIL_FAILURE;

  constructor(public payload: Object) {
  }
}

export class PasswordResetAction implements CustomAction {
  type = AuthActionTypes.PASSWORD_RESET;

  constructor(public payload: Object) {
  }
}

export class PasswordResetSuccessAction implements CustomAction {
  type = AuthActionTypes.PASSWORD_RESET_SUCCESS;

  constructor(public payload: Object) {
  }
}

export class PasswordResetFailureAction implements CustomAction {
  type = AuthActionTypes.PASSWORD_RESET_FAILURE;

  constructor(public payload: Object) {
  }
}

export class ActivationLinkGenerateAction implements CustomAction {
  type = AuthActionTypes.ACTIVATION_LINK_GENERATE;

  constructor(public payload: Object) {
  }
}

export class ActivationLinkGenerateSuccessAction implements CustomAction {
  type = AuthActionTypes.ACTIVATION_LINK_GENERATE_SUCCESS;

  constructor(public payload: Object) {
  }
}

export class ActivationLinkGenerateFailureAction implements CustomAction {
  type = AuthActionTypes.ACTIVATION_LINK_GENERATE_FAILURE;

  constructor(public payload: Object) {
  }
}

export class ForgotPasswordGenerateAction implements CustomAction {
  type = AuthActionTypes.FORGOT_PASSWORD_GENERATE;

  constructor(public payload: Object) {
  }
}

export class ForgotPasswordGenerateSuccessAction implements CustomAction {
  type = AuthActionTypes.FORGOT_PASSWORD_GENERATE_SUCCESS;

  constructor(public payload: Object) {
  }
}

export class ForgotPasswordGenerateFailureAction implements CustomAction {
  type = AuthActionTypes.FORGOT_PASSWORD_GENERATE_FAILURE;

  constructor(public payload: Object) {
  }
}

export class GenerateMultipleActivationLinksAction implements CustomAction {
  type = AuthActionTypes.MULTIPLE_ACTIVATION_LINK_GENERATE;

  constructor(public payload: Object[]) {
  }
}

export class GenerateMultipleActivationLinksSuccessAction implements CustomAction {
  type = AuthActionTypes.MULTIPLE_ACTIVATION_LINK_GENERATE_SUCCESS;

  constructor() {
  }
}

export class GenerateMultipleActivationLinksFailAction implements CustomAction {
  type = AuthActionTypes.MULTIPLE_ACTIVATION_LINK_GENERATE_FAILURE;

  constructor(public payload: Object) {
  }
}

export class ForgotPasswordResetAction implements CustomAction {
  type = AuthActionTypes.FORGOT_PASSWORD_RESET;

  constructor(public payload: PasswordReset) {
  }
}

export class ForgotPasswordResetSuccessAction implements CustomAction {
  type = AuthActionTypes.FORGOT_PASSWORD_RESET_SUCCESS;

  constructor(public payload: Object) {
  }
}

export class ForgotPasswordResetFailureAction implements CustomAction {
  type = AuthActionTypes.FORGOT_PASSWORD_RESET_FAILURE;

  constructor(public payload: Object) {
  }
}

export class LoginAddFormErrorAction implements CustomAction {
  type = AuthActionTypes.LOGIN_UPDATE_FORM_ERROR;

  constructor(public payload: Object) {
  }
}

export class LoginClearFormErrorAction implements CustomAction {
  type = AuthActionTypes.LOGIN_CLEAR_FORM_ERROR;

  constructor(public payload: string) {
  }
}

export class AuthTokenReset implements CustomAction {
  type = AuthActionTypes.AUTH_TOKEN_RESET;

  constructor() {
  }
}

export class AuthTokenLoadLocal implements CustomAction {
  type = AuthActionTypes.AUTH_TOKEN_LOAD_LOCAL;

  constructor() {
  }
}

export class SetLoginRedirectUrl implements CustomAction {
  type = AuthActionTypes.SET_LOGIN_REDIRECT_URL;

  constructor(public payload: string) {
  }
}

export class ClearLoginRedirectUrl implements CustomAction {
  type = AuthActionTypes.CLEAR_LOGIN_REDIRECT_URL;

  constructor() {
  }
}

// todo: move elsewhere is user related. Maybe profile?

export class UpdateGroupSettings implements CustomAction {
  type = AuthActionTypes.UPDATE_GROUP_SETTINGS;

  constructor() {
  }
}

export class UpdateLatestNotificationSettings implements CustomAction {
  type = AuthActionTypes.UPDATE_LATEST_NOTIFICATION_ID_SETTINGS;

  constructor(public payload: number) {
  }
}

export class DisableShowEventOnboardingSettings implements CustomAction {
  type = AuthActionTypes.DISABLE_SHOW_EVENT_ONBOARDING;

  constructor() {
  }
}

export class DisableShowRelationshipOnboardingSettings implements CustomAction {
  type = AuthActionTypes.DISABLE_SHOW_RELATIONSHIP_ONBOARDING;

  constructor() {
  }
}

export class UpdateSettings implements CustomAction {
  type = AuthActionTypes.UPDATE_SETTINGS;

  constructor(public payload: UserSettings) {
  }
}

export class ResetToken implements CustomAction {
  type = AuthActionTypes.RESET_TOKEN;

  constructor() {
  }
}

export class AcceptUpdate2019Action implements CustomAction {
  type = AuthActionTypes.ACCEPT_UPDATE2019;

  constructor() {
  }
}

export class ActivateCode implements CustomAction {
  type = AuthActionTypes.ACTIVATE_CODE;

  constructor(public payload: string) {
  }
}

export class ActivateCodeSuccess implements CustomAction {
  type = AuthActionTypes.ACTIVATE_SUCCESS;

  constructor(public payload: string) {
  }
}

export class ActivateCodeFail implements CustomAction {
  type = AuthActionTypes.ACTIVATE_FAIL;

  constructor(public payload: HttpErrorResponse) {
  }
}

export class ActivateCodeFormErrorAction implements CustomAction {
  type = AuthActionTypes.ACTIVATE_CODE_FORM_ERROR;

  constructor(public payload: Object) {
  }
}

export class TokenLoaded implements CustomAction {
  type = AuthActionTypes.TOKEN_LOADED;

  constructor() {
  }
}

export type AuthActions =
  LoginAction
  | LoginSuccessAction
  | LoginFailureAction
  | LoadUserDataAction
  | UserDataAction
  | UserDataSuccessAction
  | UserDataFailAction
  | LogoutAction
  | LogoutSuccessAction
  | AuthRefreshTokenAction
  | AuthRefreshTokenSuccessAction
  | AuthRefreshTokenFailAction
  | VerifyEmailAction
  | VerifyEmailSuccessAction
  | VerifyEmailFailureAction
  | GenerateVerifyEmailAction
  | GenerateVerifyEmailSuccessAction
  | GenerateVerifyEmailFailureAction
  | PasswordResetAction
  | PasswordResetSuccessAction
  | PasswordResetFailureAction
  | ForgotPasswordGenerateAction
  | ForgotPasswordGenerateSuccessAction
  | ForgotPasswordGenerateFailureAction
  | ForgotPasswordResetAction
  | ForgotPasswordResetSuccessAction
  | ForgotPasswordResetFailureAction
  | ActivationLinkGenerateAction
  | ActivationLinkGenerateSuccessAction
  | ActivationLinkGenerateFailureAction
  | GenerateMultipleActivationLinksAction
  | GenerateMultipleActivationLinksSuccessAction
  | GenerateMultipleActivationLinksFailAction
  | LoginAddFormErrorAction
  | LoginClearFormErrorAction
  | AuthTokenReset
  | AuthTokenLoadLocal
  | SetLoginRedirectUrl
  | ClearLoginRedirectUrl
  | UpdateGroupSettings
  | UpdateLatestNotificationSettings
  | DisableShowEventOnboardingSettings
  | UpdateSettings
  | ResetToken
  | AcceptUpdate2019Action
  | ActivateCode
  | ActivateCodeSuccess
  | ActivateCodeFail
  | TokenLoaded


